<div class="grid place-items-center">

    <!-- without switchboardImage -->
    <div class="story relative rounded-lg overflow-hidden shadow-lg hidden" *ngIf="switchboardImage == 0" style="
        background-image: url('{{mainImageUrl}}'); 
        background-size: cover; 
        background-position: center;">

        <!-- Header Section -->
        <div class="grid grid-cols-12">
            <div class="col-span-10">
                <div class="flex justify-content-left align-items-center p-3">
                    <img src="{{thumbnailFilePath}}" alt="Profile Avatar" class="profile-img me-2" />
                    <p class="avatar-title flex items-center">
                        {{postFeed}}
                    </p>
                </div>
            </div>
            <div class="col-span-2">
                <div class="flex justify-content-right align-items-center p-3">
                    <img src="assets/icons/dots-white.png" alt="Dots Icon" class="ms-4 mt-4 dots-icon-white" />
                </div>
            </div>
            <div class="col-span-12">
                <p class="text-white ps-17 font-14" style="margin-top: -25px;">{{formattedDate}}</p>
            </div>
        </div>

        <!-- Content Section -->
        <div class="content left-2 right-2 text-center px-2 rounded-lg">

            <!-- Article Link -->
            <p class="article-link py-2 m-2 mx-auto px-3">
                <a href="{{articleUrl}}" target="_blank"
                    class="avatar-link flex items-center mx-auto no-underline text-gray-800">
                    <img src="assets/icons/link-icon.png" alt="Link Icon"
                        class="rounded-circle me-1 link-icon-story" />
                    {{siteDomain}}
                </a>
            </p>

            <!-- Caption -->
            <h3 class="facebook-story-caption px-4 text-white mt-3">
                {{postTitle}}
            </h3>

            <hr class="border-t-0 h-1 opacity-100 my-4" />

            <!-- Additional Text -->
            <p class="mb-0 font-medium bold-500">This is a preview image provided by <em>Publio.ai</em></p>
        </div>
    </div>

    <!-- with switchboardImage -->
    <div class="story-switchboard relative rounded-lg overflow-hidden shadow-lg" *ngIf="switchboardImage == 1">
        <img src="{{mainImageUrl}}" class="main-image xl:h-[850px]"/>
        <!-- Header Section -->
        <div class="header-section absolute top-0 left-0">
            <div class="grid grid-cols-12">
                <div class="col-span-10">
                    <div class="flex justify-content-left align-items-center p-3">
                        <img src="assets/thumbs/{{siteDomain}}.jpg" alt="Profile Avatar" class="profile-img me-2" />
                        <p class="avatar-title flex items-center">
                            {{postFeed}}
                        </p>
                    </div>
                </div>
                <div class="col-span-2">
                    <div class="flex justify-content-right align-items-center p-3">
                        <img src="assets/icons/dots-white.png" alt="Dots Icon" class="ms-4 mt-4 dots-icon-white" />
                    </div>
                </div>
                <div class="col-span-12">
                    <p class="text-white ps-17 font-14" style="margin-top: -25px;">{{formattedDate}}</p>
                </div>
            </div>
        </div>

          <!-- Content Section -->
        <div class="content-section absolute bottom-66 text-center">

            <!-- Article Link -->
            <p class="article-link py-2 m-2 mx-auto px-3">
                <a href="{{articleUrl}}" target="_blank"
                    class="avatar-link flex items-center mx-auto no-underline text-gray-800">
                    <img src="assets/icons/link-icon.png" alt="Link Icon"
                        class="rounded-circle me-1 link-icon-story" />
                    {{siteDomain}}
                </a>
            </p>
        </div>

    </div>
</div>